export default {
	/**
	 * Returns the metrics for online device counts over time.
	 *
	 * @returns {Promise<object>}
	 */
	async onlineDevices () {}
};
